import classNames from 'classnames';
import PropTypes from 'prop-types';
import $j from 'jquery';
import React, { Component } from 'react';
import listensToClickOutside from 'react-onclickoutside';
import showVideoResponse from 'helper/uppy/videoUploader';
import Icon from '../../helper/Icon';

/* @withExternalScript({
  src: ExternalScriptsEnum.Translodit.src,
  id: ExternalScriptsEnum.Translodit.id
}) */
@listensToClickOutside
class AudioTransloaditUpload extends Component {
  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
    const blockId = this.props.blockItem._id;
    let uploading = false;
    let transcoding = false;
    if (window.blockUpload[blockId] && window.blockUpload[blockId].status === 'uploading') {
      uploading = true;
    }
    if (window.blockUpload[blockId] && window.blockUpload[blockId].status === 'transcoding') {
      transcoding = true;
    }
    this.state = {
      uploading,
      transcoding
    };
  }

  componentDidMount() {
    window.$ = $j;
    /* const blockId = this.props.blockItem._id;
    const cardId = this.props.cardId;
    this.transloaditRef = $j(`#${blockId}audioInputForm`).transloadit({
      wait: true,
      triggerUploadOnFileSelection: true,
      modal: false,
      autoSubmit: false,
      fields: true,
      params: {
        auth: {
          expires: '2029/04/12 14:51:24+00:00',
          key: '1a5298e08ef211e7b02ae70dd9f75b7d'
        },
        template_id: 'adf198e0c93911e781b1fd18b7531e1e'
      },
      onFileSelect: this.onFileSelect(blockId, cardId),
      onProgress: this.onProgress(blockId, cardId),
      onExecuting: this.onExecuting(blockId, cardId),
      onSuccess: this.onSuccess(blockId, cardId)
    }); */
  }

  /*   onFileSelect = (blockId, cardId) => file => {
    this.refs.audioFileUploader.value = null;
    this.toggleMenu(false);
    this.setState({
      uploading: true
    });
    const name = file.name;
    const startedAt = new Date();
    window.blockUpload[blockId] = {
      status: 'uploading',
      request: this.transloaditRef,
      blockId,
      cardId
    };
    // blockId = null, cardId, level, name, request, startedAt
    window.eventEmitter.emitEvent('begin', [
      blockId,
      cardId,
      'block',
      name,
      this.transloaditRef,
      startedAt
    ]);
  }; */

  /* onProgress = (blockId, cardId) => (bytesReceived, bytesExpected) => {
    const progress = parseFloat((bytesReceived / bytesExpected) * 100, 10);
    const loaded = bytesReceived;
    const total = bytesExpected;
    // blockId, cardId, loaded, level, progress, request, total
    window.eventEmitter.emitEvent('uploading', [
      blockId,
      cardId,
      loaded,
      'block',
      progress,
      null,
      total
    ]);
    $j('.upload-progress').text(((bytesReceived / bytesExpected) * 100).toFixed(2) + '%');
  }; */

  /*   onExecuting = blockId => () => {
    this.setState({
      uploading: false,
      transcoding: true
    });
    window.blockUpload[blockId].status = 'transcoding';
    window.eventEmitter.emitEvent('transcodingBegin', [blockId]);
  }; */

  /* onSuccess = (blockId, cardId) => (result) => {
    console.log('transcodingEnd');
    this.setState({
      uploading: false,
      transcoding: false
    });
    window.eventEmitter.emitEvent('transcodingEnd', [
      cardId,
      blockId,
      this.getUrls(result).mp3AudioUrl
    ]);
  }; */

  /*  getUrls = (result) => {
    const mp3AudioUrl = result.results.mp3_encoded[0].ssl_url;
    return { mp3AudioUrl };
  }; */

  toggleMenu = show => {
    if (show) return $j('.AudioTransloaditUpload .menu').addClass('menu--active');
    return $j('.AudioTransloaditUpload .menu').removeClass('menu--active');
  };

  handleClickOutside() {
    this.toggleMenu(false);
  }

  cancelUpload = () => {
    this.transloaditRef &&
      this.transloaditRef.data('transloadit.uploader').cancel &&
      this.transloaditRef &&
      this.transloaditRef.data('transloadit.uploader').cancel();
  };

  clickChildLabel = e => {
    $j(e.target)
      .find('label')
      .trigger('click');
  };

  preventFormSubmit = e => {
    e.preventDefault();
    return false;
  };

  renderImageOrStatus = src => {
    if (this.state.uploading) {
      return (
        <div className="upload">
          <strong className="upload__text">Uploading...</strong>
          {/* <button className="upload__action" onClick={this.cancelUpload}>Cancel</button> */}
        </div>
      );
    }
    if (this.state.transcoding) {
      return (
        <div className="upload">
          <strong className="upload__text">Transcoding audio now...</strong>
          {/* <button className="upload__action" onClick={this.cancelUpload}>Cancel</button> */}
        </div>
      );
    }
    if (src && src.length > 0) {
      return [
        <div key={1} className="item-media__thumb-container">
          <figure
            className="item-media__thumb"
            style={{
              backgroundImage: 'url(' + window.constants.imageUrl + 'audio-file.png)',
              backgroundSize: '100%'
            }}
          />
        </div>,
        <div key={2} className="item-media__name">
          <div className="item-media__text" />
        </div>
      ];
    }
    if (!src || src === '') {
      return (
        <div className="item-media__name">
          <div className="item-media__text-placeholder">Upload an audio file.</div>
        </div>
      );
    }
  };

  showFilePicker = () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    const blockId = this.props.blockItem._id;
    const cardId = this.props.cardId;
    const self = this;
    // this.context.showLoading();
    window.fs_filepicker
      .picker({
        fromSources: [
          'local_file_system',
          'url',
          'googledrive',
          'dropbox',
          'gmail',
          'video',
          'audio'
        ],
        accept: ['audio/*'],
        maxFiles: 1,
        minFiles: 1,
        onOpen: () => {
          // this.context.hideLoading();
        },
        onFileUploadFinished: data => {
          self.audioUpload(data);
        }
      })
      .open();
  };

  audioUpload = result => {
    // console.log('transcodingEnd');
    /* this.setState({
      uploading: false,
      transcoding: false
    }); */
    /* window.eventEmitter.emitEvent('transcodingEnd', [
      cardId,
      blockId,
      this.getUrls(result).mp3AudioUrl
    ]); */
    this.props.uploadDone(result.url);
  };

  renderMediaMenu = (src, srcAvailable) => {
    const buttonClass = classNames(
      'menu__toggle',
      'item-media__actions-link' /* { 'item-media__actions-link': srcAvailable, 'item-media__icon item-media__icon-large': !srcAvailable } */
    );

    // console.log('pathUName:: ', pathUName);
    const blockId = this.props.blockItem._id;
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    return (
      <div className="media-menu">
        <div className="menu">
          {!this.state.uploading && !this.state.transcoding && (
            <button className={buttonClass} onClick={this.toggleMenu}>
              Change
            </button>
          )}
          <div>
            <div className="menu__content menu__content--right menu__content">
              <div className="menu__listWrapper">
                <ul className="menu__list">
                  <li className="menu__item" onClick={this.clickChildLabel}>
                    <span>
                      <label
                        onClick={
                          useFilestackFilePicker
                            ? this.showFilePicker
                            : () => showVideoResponse(blockId, this.audioUpload, 'audio-upload')
                        }
                        className="button"
                      >
                        <span>
                          <span className="menu__icon">
                            <Icon
                              icon="file-upload-2"
                              size="15px"
                              viewBox="0 0 15 15"
                              fill="#313537"
                            />
                          </span>
                          {!srcAvailable ? 'Upload media' : 'Replace media'}
                        </span>
                      </label>
                      {/* <form id={`${blockId}audioInputForm`}>
                        <input
                          name="video_file"
                          ref="audioFileUploader"
                          type="file"
                          id="s0.423029640158747"
                          accept="audio/midi, audio/mpeg, audio/webm, audio/ogg, audio/wav, audio/x-wav"
                          style={{ display: 'none' }}
                        />
                        <input type="hidden" name="pathuname" value={pathUName} />
                        <input
                          type="hidden"
                          name="signature"
                          value="7f25fddc1c8b715ff2e9dd4c008ea34132858cba"
                        />
                      </form> */}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { audioUrl } = this.props;
    const audioAvailable = audioUrl && audioUrl !== '' && audioUrl.length > 0;
    return (
      <div className="AudioTransloaditUpload">
        <div className="block-edit-field-embed">
          <div className="item-media__row">
            {this.renderImageOrStatus(audioUrl)}
            {this.renderMediaMenu(this.props.src, audioAvailable)}
          </div>
        </div>
      </div>
    );
  }
}

export default AudioTransloaditUpload;
